import { render, staticRenderFns } from "./options-menu.vue?vue&type=template&id=bffabcf2&scoped=true"
import script from "./options-menu.vue?vue&type=script&lang=js"
export * from "./options-menu.vue?vue&type=script&lang=js"
import style0 from "./options-menu.vue?vue&type=style&index=0&id=bffabcf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffabcf2",
  null
  
)

export default component.exports